import { TextField } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import React, { ReactNode } from 'react';
import { Control, Controller, FieldValues, Path } from 'react-hook-form';

import { Field } from '../types';

import { NoraButton } from '../../../../../../common/components/v2';
import styles from '../styles.module.scss';

export interface FormProps<T extends FieldValues> {
  control: Control<T>;
  fields: Field[];
  onSubmit: () => void;
  isValid: boolean;
  children?: ReactNode;
  isDisabled: boolean;
}

const Form = <T extends FieldValues>({
  control,
  fields,
  onSubmit,
  isValid,
  children,
  isDisabled,
}: FormProps<T>) => (
  <div className={styles.Form}>
    {fields.map(({ name, label, type, placeholder }) => (
      <Controller
        key={name}
        control={control}
        name={name as Path<T>}
        render={({ field, fieldState }) => (
          <div>
            {type === 'text' ? (
              <TextField
                fullWidth
                required
                placeholder={placeholder}
                error={!!fieldState.error?.message}
                id={name}
                label={label}
                helperText={fieldState.error?.message}
                variant="standard"
                {...field}
              />
            ) : type === 'date' ? (
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label={label}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      required: true,
                      placeholder,
                      error: !!fieldState.error?.message,
                      id: name,
                      helperText: fieldState.error?.message,
                      variant: 'standard',
                    },
                  }}
                  {...field}
                />
              </LocalizationProvider>
            ) : type === 'textarea' ? (
              <TextField
                minRows={4}
                fullWidth
                required
                placeholder={placeholder}
                error={!!fieldState.error?.message}
                id={name}
                label={label}
                helperText={fieldState.error?.message}
                variant="standard"
                multiline
                {...field}
              />
            ) : (
              <span>Field is not supported</span>
            )}
          </div>
        )}
      />
    ))}
    {children}
    <NoraButton onClick={onSubmit} disabled={!isValid || isDisabled}>
      Preview
    </NoraButton>
  </div>
);

export default Form;
